<template>
  <div class="operational-processes-container">
    <!-- <my-form /> -->
    <!-- Toastification loading content export -->
    <toastification-loading-content ref="loadingToast" />

    <b-row v-if="showFilters" class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <!-- Filters (sin funcionalidad por ahora) -->
    <filter-modal
      @action="buildFilters()"
      @clear="clearSearchFilters()"
      v-if="showFilters"
    >
      <template v-slot:main-filters>
        <!-- Filtros se agregarán en el futuro -->
        <filters
          :folio-filter.sync="folioFilter"
          :report-number-filter.sync="reportNumberFilter"
          :sirh-filter.sync="sirhFilter"
          :rems-filter.sync="remsFilter"
          :type-of-maintenance-filter.sync="typeOfMaintenanceFilter"
          :is-test-mode-enabled-filter.sync="isTestModeEnabledFilter"
          :activities-filter.sync="activitiesFilter"
          :units-filter.sync="unitsFilter"
          :status-filter.sync="statusFilter"
          :created-at-filter.sync="createdAtFilter"
          :unit-options="unitOptions"
          :activity-options="activityOptions"
        />
      </template>
    </filter-modal>

    <Transition name="slide-right-left">
      <div v-if="!showFilters && isFilterPanelOpen" class="filters-panel-fullscreen">
        <div class="filters-panel-header">
          <p class="h4 text-capitalize mb-2 text-white">
            {{ $t("messages.info.advanced_search") }}
          </p>
          <b-button
            variant="link"
            size="sm"
            @click="isFilterPanelOpen = false"
            class="text-dark p-0"
          >
            <feather-icon icon="XIcon" size="24" />
          </b-button>
        </div>
        <div class="filters-panel-content">
          <!-- Filtros se agregarán en el futuro -->
           <filters
            :folio-filter.sync="folioFilter"
            :report-number-filter.sync="reportNumberFilter"
            :sirh-filter.sync="sirhFilter"
            :rems-filter.sync="remsFilter"
            :type-of-maintenance-filter.sync="typeOfMaintenanceFilter"
            :is-test-mode-enabled-filter.sync="isTestModeEnabledFilter"
            :activities-filter.sync="activitiesFilter"
            :units-filter.sync="unitsFilter"
            :status-filter.sync="statusFilter"
            :created-at-filter.sync="createdAtFilter"
            :unit-options="unitOptions"
            :activity-options="activityOptions"
          />
        </div>
        <div class="filters-panel-footer">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="clearSearchFilters()"
            class="text-capitalize"
          >
            {{ $t("messages.info.clear_filters") }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="applyFilters()"
            class="text-capitalize"
          >
            {{ $t("search") }}
            <feather-icon icon="SearchIcon" />
          </b-button>
        </div>
      </div>
    </Transition>

    <!-- Table Container Card -->
    <b-card-group
      v-show="showFilters || !isFilterPanelOpen"
      deck
      :class="{ 'mx-2': showFilters, 'm-0': !showFilters }"
    >
      <Transition name="slide-left-right">
        <b-card class="m-0" no-body v-if="!isFormOpen && !isFinishMaintenanceOpen">
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label class="text-capitalize">{{ $t("table.show") }}</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label class="text-capitalize">{{ $t("table.entries") }}</label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" :md="'6'">
                <div
                  class="d-flex align-items-center justify-content-end"
                  :class="{ 'w-100': !showFilters }"
                >
                  <b-form-input
                    data-cy="search"
                    v-model="searchQuery"
                    :class="
                      showFilters ? 'd-inline-block mr-1' : 'd-inline-block mr-1 w-75'
                    "
                    :placeholder="$t('table.search') + '...'"
                  />

                  <!-- Filter button for slot mode -->
                  <b-button-group v-if="!showFilters">
                    <b-button
                      @click="isFilterPanelOpen = true"
                      class="buttonFilter cursor-pointer d-flex align-items-center"
                      data-cy="filter-btn"
                    >
                      <b-icon-filter-circle-fill scale="1.1" />
                      <span class="align-middle ml-1 text-capitalize">{{
                        $t("filters")
                      }}</span>
                    </b-button>
                    <toggle-clear-filter
                      @clear-search-filters="clearSearchFilters"
                      :filters-count="filtersCount"
                    />
                  </b-button-group>

                  <b-button
                    v-if="$can('create', 'ExternalPersonnelAccessControl') && showFilters"
                    variant="secondary"
                    @click="openAdd()"
                    :class="{ 'ml-1': !showFilters }"
                  >
                    <span class="text-nowrap text-capitalize">
                      {{ $t("actions.add") }}
                    </span>
                  </b-button>

                  <!-- Download button -->
                  <b-button
                    v-if="$can('export', 'ExternalPersonnelAccessControl') && showFilters"
                    @click="exportExcel()"
                    variant="success"
                    class="text-capitalize ml-1"
                    :class="{ 'px-2': !showFilters }"
                    type="button"
                    :disabled="disableExport"
                    v-b-tooltip.hover
                    :title="$t('messages.export.title')"
                  >
                    <feather-icon icon="DownloadCloudIcon" size="15" />
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-table
            bordered
            striped
            ref="refListTable"
            class="position-relative"
            :items="fetchList"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            :empty-text="$t('no_record_found')"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #head()="data">
              <span> {{ $tc(data.label, 1) }}</span>
            </template>

            <template #head(name)="data">
              <span> {{ $tc(data.label, 2) }}</span>
            </template>

            <template #head(created_at)="data">
              <span> {{ $tc(data.label, 2) }}</span>
            </template>

            <template #head(actions)="data">
              <span> {{ $tc(data.label, 2) }}</span>
            </template>

            <!-- Column: Actions -->
            <!-- Column: Estatus mantenimiento -->
            <template #cell(employee.full_name_id)="data">
              <span style="min-width: 180px; display: inline-block">
                {{ data.item.employee.full_name_id }}
              </span>
            </template>

            <template #cell(status)="data">              
              <b-badge
                v-if="data.item.status === 'in_progress'"
                variant="light-success"
                class="text-capitalize"
              >
                {{data.item.status_label}}
              </b-badge>
              <b-badge
                v-if="data.item.status === 'partial'"
                variant="light-warning"
                class="text-capitalize"
              >
                {{data.item.status_label}}
              </b-badge>
              <b-badge
                v-if="data.item.status === 'finished'"
                variant="light-info"
                class="text-capitalize"
              >
                {{data.item.status_label}}
              </b-badge>
            </template>

            <!-- Column: Actividades / Tipo de atención (array) -->
            <template #cell(activities)="data">
              <div v-if="Array.isArray(data.value)">
                <b-badge
                  v-for="(act, idx) in data.value"
                  :key="idx"
                  variant="light-primary"
                  class="mr-25 mb-25"
                >
                  {{ act.description }}
                </b-badge>
              </div>
              <span v-else>{{ data.value }}</span>
            </template>

            <!-- Column: Sistemas (array) -->
            <template #cell(systems)="data">
              <div v-if="Array.isArray(data.value)">
                <b-badge
                  v-for="(sys, idx) in data.value"
                  :key="idx"
                  variant="light-info"
                  class="mr-25 mb-25"
                >
                  {{ sys }}
                </b-badge>
              </div>
              <span v-else>{{ data.value }}</span>
            </template>
            
            <!-- Column: Empleados (array) -->
            <template #cell(employees)="data">
              <div v-if="Array.isArray(data.value)">
                <b-badge
                  v-for="(e, idx) in data.value"
                  :key="idx"
                  variant="light-info"
                  class="mr-25 mb-25"
                >
                  {{ e.full_name_id ? e.full_name_id : '' }}
                </b-badge>
              </div>
              <span v-else>{{ data.value }}</span>
            </template>
            
            <!-- Tipo de mantenimiento -->
            <template #cell(type_of_maintenance)="data">
              <span>{{ data.value ? data.value : "-" }}</span>
            </template>
            
            <!-- Tenant de mantenimiento -->
            <template #cell(tenant.name)="data">
              <span>{{ data.value ? data.value : "-" }}</span>
            </template>

            <!-- Column: Dispositivos en mantenimiento (array) -->
            <template #cell(device_proxies)="data">
              <div v-if="Array.isArray(data.value) && data.value.length">
                <b-badge
                  v-for="(device_proxy, idx) in data.value"
                  :key="idx"
                  variant="light-warning"
                  class="mr-25 mb-25"
                >
                  {{
                    device_proxy &&
                    device_proxy.cameras_proxy &&
                    device_proxy.cameras_proxy.camera
                      ? device_proxy.cameras_proxy.camera.name
                      : ""
                  }}
                </b-badge>
              </div>
              <span v-else class="text-muted">-</span>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <b-button
                :id="`actions-${uid}-${data.item.id}`"
                tabindex="0"
                variant="white"
                class="px-1 btn-y"
              >
                <feather-icon
                  data-cy="actions"
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </b-button>
              <b-popover
                :target="`actions-${uid}-${data.item.id}`"
                triggers="focus"
                placement="bottom"
                custom-class="popover-p-0"
                variant="white"
              >
                <b-list-group class="m-0">
                  <b-list-group-item v-if="$can('update', 'ExternalPersonnelAccessControl')" @click="openEdit(data.item)" class="border-0" button>
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">{{ $t("actions.edit") }}</span>
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$can('finish_maintenance', 'ExternalPersonnelAccessControl') && data.item.status !== 'finished'"
                    @click="finishMaintenance(data.item)"
                    class="border-0"
                    button
                  >
                    <feather-icon icon="CheckCircleIcon" />
                    <span class="align-middle ml-50">
                      {{ $t("operational_security.operational_processes.finish_maintenance") }}
                    </span>
                  </b-list-group-item>
                  <b-list-group-item
                    @click="confirmDelete(data.item.id)"
                    v-if="$can('delete', 'ExternalPersonnelAccessControl')"
                    class="border-0" button
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50 text-capitalize">{{
                      $t("actions.delete")
                    }}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-popover>
            </template>
          </b-table>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted text-capitalize">{{
                  $t("table.showing", {
                    from: dataMeta.from,
                    to: dataMeta.to,
                    of: dataMeta.of,
                  })
                }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <Pagination
                  data-cy="pagination"
                  :totalList="totalList"
                  :currentPage="currentPage"
                  @updatePagination="update"
                  :perPage="perPage"
                />
              </b-col>
            </b-row>
          </div>
        </b-card>
      </Transition>

      <!-- Step Form (slides in when adding/editing) -->
      <Transition name="slide-right-left">
        <b-card v-if="isFormOpen" class="m-0" no-body>
          <step-form
            :is-add="isAdd"
            :item-edit="itemEdit"
            :show-filters="showFilters"
            :first-item="localItems.length > 0 ? localItems[localItems.length - 1] : null"
            @close="closeForm"
            @saved="onFormSaved"
            :unit-options="unitOptions"
            :initital-form-step="inititalFormStep"
          />
        </b-card>
      </Transition>

      <!-- Finish Maintenance Panel -->
      <Transition name="slide-right-left">
        <b-card v-if="isFinishMaintenanceOpen" class="m-0" no-body>
          <div class="p-2">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h4 class="mb-0">{{ $t("operational_security.operational_processes.finish_maintenance") }}</h4>
              <b-button
                variant="flat-secondary"
                size="sm"
                @click="cancelFinishMaintenance"
              >
                <feather-icon icon="XIcon" size="18" />
              </b-button>
            </div>

            <!-- Inmueble info -->
            <b-form-group :label="$t('operational_security.operational_processes.unit')" label-for="finish-inmueble">
              <b-form-input
                id="finish-inmueble"
                :value="finishItem.unit ? finishItem.unit.description : ''"
                disabled
              />
            </b-form-group>

            <!-- Tenant select -->
            <!-- <b-form-group label="Mover tenant fin" label-for="finish-tenant">
              <v-select
                id="finish-tenant"
                v-model="finishTenant"
                :options="tenantOptions"
                :reduce="(val) => val.label"
                placeholder="Seleccione tenant"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              />
            </b-form-group> -->

            <!-- Actions -->
            <div class="d-flex justify-content-end mt-2">
              <b-button
                variant="outline-secondary"
                class="mr-1"
                @click="cancelFinishMaintenance"
                :disabled="isFinishingMaintenance"
              >
                Cancelar
              </b-button>
              <b-button variant="success" @click="confirmFinishMaintenance" :disabled="isFinishingMaintenance">
                <b-spinner v-if="isFinishingMaintenance" small />
                Confirmar
              </b-button>
            </div>
          </div>
        </b-card>
      </Transition>
    </b-card-group>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ref, computed, onMounted, watch, getCurrentInstance } from "@vue/composition-api";
import useList from "./useList";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import ToggleClearFilter from "@/components/Filters/ToggleClearFilter.vue";
import StepForm from "./StepForm.vue";
import Swal from "sweetalert2";
import flatPickr from "vue-flatpickr-component";
import MyForm from "./MyForm.vue";
import Filters from "./Filters.vue";
import router from "@/router";

export default {
  name: "OperationalProcesses",
  components: {
    MyForm,
    BreadcrumbMenu,
    ButtonFilters,
    ToggleClearFilter,
    FilterModal,
    Pagination,
    vSelect,
    ToastificationLoadingContent,
    StepForm,
    Filters,
    flatPickr,
  },
  props: {
    filters: {
      type: Object | Array,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const isFilterPanelOpen = ref(false);
    const loadingToast = ref(null);
    const isFormOpen = ref(false);
    const isAdd = ref(true);
    const itemEdit = ref({});
    const isFinishMaintenanceOpen = ref(false);
    const finishItem = ref({});
    const finishTenant = ref(null);
    const uid = Math.random().toString(36).substring(2, 10);
    const isFinishingMaintenance = ref(false);

    const initialFormStep = ref(1);

    const toast = useToast();
    const { t } = useI18nUtils();

    // Tenant options from store
    const tenantOptions = computed(() => store.getters["tenant/getSelectedItems"]);

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      action,
      disableExport,
      filtersCount,
      clearSearchFilters,
      buildFilters,
      loadingToast: listLoadingToast,
      addItem,
      removeItem,
      localItems,
      folioFilter,
      reportNumberFilter,
      sirhFilter,
      remsFilter,
      typeOfMaintenanceFilter,
      isTestModeEnabledFilter,
      activitiesFilter,
      activityOptions,
      unitOptions,
      unitsFilter,
      statusFilter,
      createdAtFilter,
      formatDateAssigned,
    } = useList(props.showFilters, props.filters);

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: context.parent.$i18n.t("messages.delete.title"),
        text: context.parent.$i18n.t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: context.parent.$i18n.t("actions.delete"),
        cancelButtonText: context.parent.$i18n.t("actions.cancel"),
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("external_personnel_access_control/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const update = (data) => {
      currentPage.value = data;
    };

    const trans = {
      "messages.export.download": t("messages.export.download"),
      "messages.export.Generating_file": t("messages.export.Generating_file"),
      "messages.error.server_error": t("messages.error.server_error"),
    };

    const exportExcel = () => {
      action.value = "export";
      fetchList();
    };

    const applyFilters = () => {
      buildFilters();
      isFilterPanelOpen.value = false;
    };

    const openAdd = () => {
      if (Object.keys(router.currentRoute.query).length > 0) {
        router.replace({ query: {} })
      }

      initialFormStep.value = 1;

      isAdd.value = true;
      itemEdit.value = {};
      isFormOpen.value = true;
    };

    const openEdit = (item, formStep = 1) => {
      if(formStep === 1) {
        if (Object.keys(router.currentRoute.query).length > 0) {
          router.replace({ query: {} })
        }
      }

      initialFormStep.value = formStep;

      isAdd.value = false;

      let panel_user = null;

      if (item.panel_user) {
        panel_user = {
          ...item.panel_user,
          value: item.panel_user?.userNumber,
          label: item.panel_user?.userName,
        };
      }
      
      itemEdit.value = {
        ...item,
        activities: item.activities.map((act) => act.id),
        unit: {
          ...item.unit,
          value: item.unit?.id,
          label: item.unit?.description,
        },
        panel_user,
      };

      isFormOpen.value = true;
    };

    const closeForm = () => {
      isFormOpen.value = false;
    };

    const onFormSaved = (formData) => {
      /* if (formData) {
        addItem(formData);
      } */
      isFormOpen.value = false;
      refetchData();
    };

    const deleteItem = async (item) => {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción eliminará el registro.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        removeItem(item.id);
        toast({
          component: ToastificationContent,
          props: {
            title: "Registro eliminado",
            icon: "TrashIcon",
            variant: "success",
          },
        });
      }
    };

    const finishMaintenance = (item) => {
      finishItem.value = { ...item };
      finishTenant.value = null;
      isFinishMaintenanceOpen.value = true;
    };

    const cancelFinishMaintenance = () => {
      isFinishMaintenanceOpen.value = false;
      finishItem.value = {};
      finishTenant.value = null;
    };

    const confirmFinishMaintenance = () => {
      // Update the item with tenant_fin via store
      isFinishingMaintenance.value = true;
      store.dispatch("external_personnel_access_control/finish_maintenance", {
        id: finishItem.value.id,
        params: { id_tenant: finishTenant.value },
      }).then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Mantenimiento finalizado",
            icon: "CheckCircleIcon",
            variant: "success",
          },
        });

        isFinishMaintenanceOpen.value = false;
        finishItem.value = {};
        finishTenant.value = null;
        refetchData();
      }).catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: error?.response?.data?.message || "Error finalizando el mantenimiento",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }).finally(() => {
        isFinishingMaintenance.value = false;
      });
    };

    onMounted(() => {
      store.dispatch("tenant/getAll", { max: 100 });
    });

    const vm = getCurrentInstance().proxy;

    watch(
      () => (vm.$route && vm.$route.query ? vm.$route.query.device_proxy_id : null),
      async (newId) => {
        const { id } = vm.$route.query;
        
        if(id){
          closeForm();
          
          store.dispatch("external_personnel_access_control/get", id).then(response => {
            const { data } = response;
            
            openEdit(data, 2);
          });
        }
      },
      {
        immediate: true,
      }
    );

    return {
      // Table
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      // UI state
      isFilterPanelOpen,
      isFormOpen,
      isAdd,
      itemEdit,
      loadingToast,
      isFinishMaintenanceOpen,
      finishItem,
      finishTenant,
      uid,
      tenantOptions,
      localItems,

      // Actions
      update,
      exportExcel,
      applyFilters,
      openAdd,
      openEdit,
      closeForm,
      onFormSaved,
      deleteItem,
      finishMaintenance,
      cancelFinishMaintenance,
      confirmFinishMaintenance,

      // Export
      disableExport,

      // Filters
      filtersCount,
      clearSearchFilters,
      buildFilters,
      folioFilter,
      reportNumberFilter,
      sirhFilter,
      remsFilter,
      typeOfMaintenanceFilter,
      isTestModeEnabledFilter,
      activitiesFilter,
      activityOptions,
      unitOptions,
      unitsFilter,
      statusFilter,
      createdAtFilter,

      formatDateAssigned,
      confirmDelete,
      isFinishingMaintenance,

      inititalFormStep: initialFormStep,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/utilities/transitions";

.operational-processes-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.spinner {
  margin-top: calc(50% - 100px);
  margin-left: 50%;
}

.filters-panel-fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 0;
}

.filters-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.filters-panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 1.5rem;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.filters-panel-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  flex-shrink: 0;
}

.dark-layout {
  .filters-panel-fullscreen {
    background-color: #283046;
    color: #b4b7bd;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  .filters-panel-header {
    border-bottom-color: rgba(255, 255, 255, 0.05);
  }

  .filters-panel-footer {
    border-top-color: #3b4253;
  }

  .filters-panel-content {
    &::-webkit-scrollbar-track {
      background: #161d31;
    }

    &::-webkit-scrollbar-thumb {
      background: #3b4253;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #4b5563;
    }
  }
}
</style>

